__turbopack_context__.v({
  "dropdown": "ContextMenu-module-scss-module__pMRmMa__dropdown",
  "item": "ContextMenu-module-scss-module__pMRmMa__item",
  "itemSection": "ContextMenu-module-scss-module__pMRmMa__itemSection",
  "target": "ContextMenu-module-scss-module__pMRmMa__target",
});
